import { render } from "./WidgetsPanel.vue?vue&type=template&id=55491102&scoped=true"
import script from "./WidgetsPanel.vue?vue&type=script&lang=ts"
export * from "./WidgetsPanel.vue?vue&type=script&lang=ts"

import "./WidgetsPanel.vue?vue&type=style&index=0&id=55491102&lang=scss&scoped=true"
import "./WidgetsPanel.vue?vue&type=style&index=1&id=55491102&lang=scss"
script.render = render
script.__scopeId = "data-v-55491102"

export default script